import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant } from "../../AbmLocalPage/types";
import { Rubro } from "../types/rubro";

export const createRubro = async (rubro: Rubro, tenant: ITenant) =>
  await axiosInstanceMain.post(`/admin/${tenant.path}/rubros`, rubro);
export const deleteRubro = async (idRubro: string, tenant: ITenant) =>
  await axiosInstanceMain.delete(`/admin/${tenant.path}/rubros/${idRubro}`);
export const updateRubro = async (
  idRubro: string,
  rubro: any,
  tenant: ITenant
) =>
  await axiosInstanceMain.put(`/admin/${tenant.path}/rubros/${idRubro}`, rubro);
